import { get } from 'lodash';

export const getAccessPrompt = state => get(state, 'AccessPromptState', {});



// WEBPACK FOOTER //
// ./src/common/Components/AccessPrompt/state/selectors.js